module.exports = __webpack_public_path__ + "img/icon-2_05.4456a4fa.gif";